/**
 * SkipLink - Allows keyboard users to skip navigation and jump to main content
 * Implements WCAG 2.4.1: Bypass Blocks (Level A)
 *
 * This link is visually hidden until focused via keyboard navigation.
 * When activated, it scrolls to and focuses the main content area.
 */

export function SkipLink() {
  return (
    <a href="#main-content" className="skip-link" data-testid="skip-link">
      Skip to main content
    </a>
  );
}
